// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import logger from './logger'; // Assuming logger is available here for robust logging

// Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// --- Firestore Offline Persistence ---
// This is crucial for mobile apps to handle intermittent connectivity.
try {
    enableIndexedDbPersistence(db)
        .then(() => {
            // This is purely for logging, you can use console.log if logger isn't available
            if (logger) {
                logger.info("Firestore offline persistence enabled successfully.");
            } else {
                console.log("Firestore offline persistence enabled successfully.");
            }
        })
        .catch((err) => {
            // Handle known, non-critical errors gracefully
            if (err.code === 'failed-precondition') {
                const message = "Firestore persistence failed (likely due to multiple tabs open). This is okay, app will continue with in-memory cache.";
                if (logger) logger.warn(message); else console.warn(message);
            } else if (err.code === 'unimplemented') {
                const message = "Firestore persistence is not supported in this browser environment.";
                if (logger) logger.warn(message); else console.warn(message);
            } else {
                // Handle unexpected errors
                const message = "An unexpected error occurred while enabling Firestore persistence.";
                if (logger) logger.error(message, err); else console.error(message, err);
            }
        });
} catch (e) {
    const message = "A critical error occurred trying to set up Firestore persistence.";
    if (logger) logger.error(message, e); else console.error(message, e);
}


// --- Auth Persistence ---
// This keeps the user logged in across sessions.
setPersistence(auth, browserLocalPersistence)
    .then(() => {
        // Using logger if available for consistency
        if (logger) {
            logger.info('Firebase Auth persistence set to local.');
        } else {
            console.log('Firebase Auth persistence set to local.');
        }
    })
    .catch((error) => {
        const message = "Error setting Firebase Auth persistence:";
        if (logger) logger.error(message, error); else console.error(message, error);
    });


export { app, auth, db };